import get from 'lodash/get';
import {
  hasValidSessionSelector,
  SessionService,
  setIsLoggedIn,
  setSession,
} from './session';
import { fetchPatientsAsync } from './patient';
import { UserService } from './user';
import { setLoading } from '../../store/app/actions';

export const handleSessionPromise = (sessionPromise, dispatch, getState) => {
  return sessionPromise
    .then(session => {
      dispatch(setSession(session));
      return session;
    })
    .then(session => {
      const userId = get(session, ['user', 'id']);
      return dispatch(fetchPatientsAsync(userId));
    })
    .then(() => {
      const isLoggedIn = hasValidSessionSelector(getState());
      return dispatch(setIsLoggedIn(isLoggedIn));
    });
};

export const loginAsync = (email, password) => (dispatch, getState) => {
  const sessionPromise = dispatch(SessionService.create(email, password));
  return handleSessionPromise(sessionPromise, dispatch, getState);
};

export const loginSocialAsync = (platform, token) => (dispatch, getState) => {
  const sessionPromise = dispatch(
    SessionService.createWithSocial(platform, token),
  );
  return handleSessionPromise(sessionPromise, dispatch, getState);
};

export const loginFacebookAsync = token => dispatch =>
  dispatch(loginSocialAsync('facebook', token));

export const registerUserAsync = user => dispatch => {
  return dispatch(UserService.create(user)).then(() =>
    dispatch(loginAsync(user.email, user.password)),
  );
};

export const handleLoadingState = fetchAsync => dispatch => {
  dispatch(setLoading(true));
  return dispatch(fetchAsync()).then(() => dispatch(setLoading(false)));
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/thunks.js